export default "__VITE_ASSET__BoQ6bbRT__"